/**
 * Created by StoneWang on 2020/11/27.
 */
import React from 'react';

class PriceList extends React.Component {
  render() {
    return <div>
      {this.props.children}
    </div>
  }
};
export default PriceList;



// WEBPACK FOOTER //
// ./src/routes/quotation/index.js